function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/**
 * @file 发送执行时间统计
 * @author dafo<huanghouin@baijiahulian.com>
 * @module module/timing
*/
import request from './util/request';
import configurable from './util/configurable';
import { trackID, getUserID, Config } from './util/config';

/**
 * 时间统计上报
 *
 * @function
 * @param {Object} json 要上报的数据
 * @param {Function=} callback 上报后的回调
 */
var report = configurable(function (json, callback) {
  // 要上报的数据
  var timingData = _objectSpread({
    // 当前页 URL
    url: location.href,
    // 用户的唯一标识，由后端生成写到 cookie 中
    uuid: trackID,
    // 登录用户 id
    uid: getUserID()
  }, json);
  request(Config.VERB)("".concat(Config.TIME), timingData, callback);
}, {});
var timeMap = {};

/**
 * 开始统计时间
 *
 * @function
 * @param {string} eventID 要开始统计的事件 id，需要在 [罗盘系统](http://newhabo.baijiahulian.com/analysis/#/em) 中创建
 * @return {number} 当前时间（毫秒）
 */
export var time = function time(eventID) {
  return timeMap[eventID] = +new Date();
};

/**
 * 结束时间统计
 *
 * @function
 * @param {string} eventID 要结束统计的事件 id, 需要在 [罗盘系统](http://newhabo.baijiahulian.com/analysis/#/em) 中创建
 * @return {number} 统计到消耗的时间（毫秒），当传入未经 time 方法调用过的 eventID 时，返回 -1
 */
export var timeEnd = function timeEnd(eventID) {
  var start = timeMap[eventID];
  if (!start) {
    return -1;
  }
  var elapsed = +new Date() - start;
  report({
    eventID: eventID,
    elapsed: elapsed
  });
  return elapsed;
};
export default report;